import { toEnNumber } from '.';
import REGEX from './regex';

interface ValidationResult {
  isValid: boolean;
  error: string;
}

const ERROR_MESSAGES = {
  PERSIAN_NAME: 'نام باید فقط شامل حروف فارسی باشد.',
  INVALID_EMAIL: 'ایمیل نادرست است.',
  INVALID_PHONE: 'شماره موبایل نادرست است.',
  REQUIRED: (label: string) => `${label} الزامی است.`,
} as const;

const createValidationResult = (isValid: boolean, error: string = ''): ValidationResult => ({
  isValid,
  error,
});

function nameValidator(value: string): ValidationResult {
  if (!value) return createValidationResult(true);
  const nameReg = REGEX.PERSIAN_NAME;

  const enValue = toEnNumber(value);

  if (nameReg.test(enValue)) {
    return createValidationResult(true);
  } else {
    return createValidationResult(false, 'نام باید فقط شامل حروف فارسی باشد.');
  }
}
const emailValidator = (value: string): ValidationResult => {
  if (!value) return createValidationResult(true);
  const isValid = REGEX.EMAIL.test(value);
  return createValidationResult(isValid, isValid ? '' : ERROR_MESSAGES.INVALID_EMAIL);
};

const phoneNumberValidator = (value: string): ValidationResult => {
  if (!value) return createValidationResult(true);
  const isValid = REGEX.PHONE_NUMBER.test(value);
  return createValidationResult(isValid, isValid ? '' : ERROR_MESSAGES.INVALID_PHONE);
};

const requiredValidator = (value: string, placeholder: string): ValidationResult => {
  const label = placeholder.includes('اجباری') ? placeholder.replace(/\s*\(اجباری\)\s*/, '') : placeholder;
  const isValid = Boolean(value?.trim());
  return createValidationResult(isValid, isValid ? '' : ERROR_MESSAGES.REQUIRED(label));
};
export { emailValidator, nameValidator, phoneNumberValidator, requiredValidator };
